export enum CollegeStatusEnum {
  NOT_ATTEMPTED = 'not_attempted',
  INCOMPLETE = 'incomplete',
  COMPLETED = 'completed',
}
